import { render, staticRenderFns } from "./ExternalPrenotazioniPrenotaSlotModal.vue?vue&type=template&id=85450cf4&scoped=true"
import script from "./ExternalPrenotazioniPrenotaSlotModal.vue?vue&type=script&lang=js"
export * from "./ExternalPrenotazioniPrenotaSlotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85450cf4",
  null
  
)

export default component.exports